import React from 'react';
import { Plus, FileText, Link2, Upload } from 'lucide-react';
import { Button } from './ui/button';
import { EmptyStateAddButton } from './EmptyStateAddButton';
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from './ui/dropdown-menu';
import { useLocale } from '../contexts/LocaleContext';

interface AddResourceMenuProps {
  onAddText: () => void;
  onAddLink: () => void;
  onAddDocument: () => void;
  size?: 'sm' | 'default' | 'lg';
  variant?: 'default' | 'inverse';
  label?: string;
  trigger?: React.ReactElement;
}

export const AddResourceMenu: React.FC<AddResourceMenuProps> = ({
  onAddText,
  onAddLink,
  onAddDocument,
  size = 'default',
  variant = 'default',
  label,
  trigger,
}) => {
  const { t } = useLocale();
  const triggerLabel = label ?? t('add_resource');
  const isEmptyStateTrigger = variant === 'default' && size === 'default';

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        {trigger ?? (
          isEmptyStateTrigger ? (
            <EmptyStateAddButton>{triggerLabel}</EmptyStateAddButton>
          ) : (
            <Button size={size} variant={variant}>
              <Plus className="h-4 w-4" />
              {triggerLabel}
            </Button>
          )
        )}
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        <DropdownMenuItem onClick={onAddText}>
          <FileText className="mr-2 h-4 w-4" />
          {t('resource_type_text')}
        </DropdownMenuItem>
        <DropdownMenuItem onClick={onAddLink}>
          <Link2 className="mr-2 h-4 w-4" />
          {t('resource_type_link')}
        </DropdownMenuItem>
        <DropdownMenuItem onClick={onAddDocument}>
          <Upload className="mr-2 h-4 w-4" />
          {t('resource_type_document')}
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
